const localizers = {
  'Alerts.noAlerts.txt': () => `尚未設定此報表的警示。`,
  'BirdImage.image.txt': () => `影像`,
  'BirdText.editable.tooltip.txt': () => `連按兩下可以編輯文字`,
  'ComboBox.clearFilter.txt': () => `清除篩選`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (沒有資料)`,
  'ContextMenu.selectAll.txt': () => `全部選取`,
  'ContextMenu.clearSelection.txt': () => `清除選取項目`,
  'ContextMenu.exportImage.txt': () => `匯出作為影像`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: 遞增`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: 遞減`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: 增加遞增`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: 增加遞減`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `從排序移除 ${role}`,
  'ContextMenu.removeSortLevel.txt': () => `移除排序層級`,
  'ContextMenu.sort.txt': () => `排序`,
  'ContextMenu.selectShortestPath.txt': () => `選取最短路徑`,
  'ContextMenu.explain.txt': () => `解釋資料`,
  'ContextMenu.explainRole.txt': ({role}) => `解釋 ${role}…`,
  'ContextMenu.manageColumns.txt': () => `管理欄`,
  'ContextMenu.includeMissingValues.txt': () => `包含遺漏值`,
  'DrillableTooltip.drill.txt': () => `鑽取`,
  'DrillableTooltip.tooltip.txt': () => `工具提示`,
  'DrillableTooltip.links.txt': () => `連結`,
  'DrillableTooltip.section.link.fmt': ({page}) => `到「${page}」的頁面連結`,
  'DrillableTooltip.report.link.fmt': ({report}) => `到「${report}」的報表連結`,
  'DrillableTooltip.external.link.fmt': ({url}) => `到「${url}」的外部連結`,
  'DrillableTooltip.notAvailable.txt': () => `無法使用`,
  'Breadcrumb.all.fmt': ({label}) => `所有 ${label}`,
  'BrowserCheck.title.txt': () => `WebGL 檢查`,
  'BrowserCheck.msg.txt': () => `WebGL 已停用或您的瀏覽器不支援。   \n按一下 [確定] 可以在傳統檢視器中檢視報表。`,
  'EmailUtil.subject.multiple.txt': () => `檢視報表`,
  'EmailUtil.tooLongEmail.txt': () => `電子郵件長度超過限制。傳送電子郵件時選取少一點的報表。`,
  'HiddenSectionDialog.close.txt': () => `關閉`,
  'HiddenSectionDialog.export.txt': () => `匯出 PDF`,
  'InfoPanel.information.txt': () => `資訊`,
  'InfoPanel.comments.txt': () => `註解`,
  'InfoPanel.alerts.txt': () => `警示`,
  'IncomingFilters.promptbars.txt': () => `提示列`,
  'Information.title.txt': () => `標題`,
  'Information.name.txt': () => `名稱:`,
  'Information.description.txt': () => `說明:`,
  'Information.displayRules.txt': () => `顯示規則:`,
  'Information.graphLevel.txt': () => `圖形層級`,
  'Information.reportLevel.txt': () => `報表層級`,
  'Information.legend.txt': () => `圖例`,
  'Information.incomingFilters.txt': () => `傳入篩選:`,
  'Information.noIncomingFilters.txt': () => `沒有傳入篩選`,
  'Information.dataSourceFilters.txt': () => `資料來源篩選:`,
  'Information.interactiveFilters.txt': () => `互動式篩選:`,
  'MobileContainer.mobileBIMessage.txt': () => `在您的行動裝置上存取 SAS 報表。`,
  'ObjectTypes.report.txt': () => `報表`,
  'ObjectTypes.Report.BI.txt': () => `SAS 報表 (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `預存程式報表`,
  'ObjectTypes.StoredProcess.txt': () => `預存程式`,
  'MissingValues.label.txt': () => `(遺漏值)`,
  'PromptContainer.apply.txt': () => `確定`,
  'PromptContainer.cancel.txt': () => `取消`,
  'PromptContainer.close.txt': () => `關閉`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `必須是介於 ${min} 和 ${max} 之間的值 (包含)。`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `請指定有效的數值。`,
  'TextFieldTypeAhead.validation.string.txt': () => `所指派的資料的值無效。`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `輸入: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `輸入: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `輸入 ${placeholderLabel}…`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min}–${max}`,
  'Slider.missingValues.txt': () => `遺漏值`,
  'Slider.missingValues.tooltip.fmt': ({rangeLabel}) => `${rangeLabel} 包含遺漏值`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `返回`,
  'ReportContainer.reportCorrupted.txt': () => `報表已毀損`,
  'ReportContainer.themeLoadFailed.txt': () => `載入報表主題失敗。`,
  'ReportContainer.restoreButton.tip.txt': () => `還原報表`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `報表已還原`,
  'ReportContainer.renderError.txt': () => `發生錯誤。表報無法顯示。`,
  'ReportContainer.component.renderError.txt': () => `發生錯誤。元件無法呈現。`,
  'ReportContentPage.open.txt': () => `開啟…`,
  'ReportContentPage.refreshReport.txt': () => `重新整理報表`,
  'ReportContentPage.editReport.txt': () => `編輯報表`,
  'ReportContentPage.print.txt': () => `列印…`,
  'ReportContentPage.email.txt': () => `電子郵件…`,
  'ReportContentPage.export.txt': () => `匯出到 Excel…`,
  'ReportContentPage.reportProperties.txt': () => `報表屬性`,
  'ReportContentPage.shareReport.txt': () => `共用報表`,
  'ReportContentPage.enableOverlays.txt': () => `啟用物件覆疊`,
  'ReportContentPage.disableOverlays.txt': () => `停用物件覆疊`,
  'ReportContentPage.link.txt': () => `連結…`,
  'ReportContentPage.settings.txt': () => `設定…`,
  'ReportContentPage.editPlayback.txt': () => `編輯回放`,
  'ReportContentPage.playReport.txt': () => `播放報表`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `顯示提示篩選`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `隱藏提示篩選`,
  'ReportContentPage.reportFilters.txt': () => `報表層級`,
  'ReportContentPage.pageFilters.txt': () => `頁面層級`,
  'ReportContentPage.refreshRequired.txt': () => `需要重新整理報表`,
  'ReportContentPage.infoButton.tip.txt': () => `資訊面板`,
  'ReportContentPage.backButton.tip.txt': () => `檢視全部的報表`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `更多選項`,
  'ReportContentPage.itemGroupName.txt': () => `報表`,
  'ReportContentPage.maximizeButton.tip.txt': () => `最大化報表`,
  'ReportContentPage.closeButton.txt': () => `關閉報表`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `報表已最大化`,
  'ReportContentPage.resetReportState.txt': () => `還原預設報表狀態`,
  'ReportContentPage.summary.txt': () => `顯示摘要`,
  'ReportManagerPage.objectMenu.open.txt': () => `開啟`,
  'ReportManagerPage.objectMenu.edit.txt': () => `編輯`,
  'ReportManagerPage.objectMenu.summary.txt': () => `摘要`,
  'ReportManagerPage.objectMenu.properties.txt': () => `屬性`,
  'ReportManagerPage.objectMenu.email.txt': () => `電子郵件…`,
  'ReportManagerPage.objectMenu.print.txt': () => `列印`,
  'ReportManagerPage.browseReportsButton.txt': () => `瀏覽報表`,
  'ReportManagerPage.newReportButton.txt': () => `新增報表`,
  'ReportManagerPage.emptyView.message.txt': () => `找不到報表。`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `瀏覽報表`,
  'ReportManagerPage.tableView.name.txt': () => `名稱`,
  'ReportManagerPage.tableView.author.txt': () => `作者`,
  'ReportManagerPage.tableView.lastModified.txt': () => `上次修改時間`,
  'ReportManagerPage.openButton.tip.txt': () => `開啟報表`,
  'ReportManagerPage.emailButton.tip.txt': () => `電子郵件報表`,
  'ReportManagerPage.printButton.tip.txt': () => `列印報表到 PDF`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `報表屬性`,
  'ReportObject.multipleReferences.error.txt': () => `報表物件無法在多個內容環境中使用。`,
  'ReportObject.notFound.error.txt': () => `在指定報表中找不到物件名稱。`,
  'ReportObject.invalidPage.error.txt': () => `指定的頁面無效。`,
  'ReportPropertiesDialog.open.txt': () => `開啟`,
  'ReportPropertiesDialog.close.txt': () => `關閉`,
  'ReportPropertiesDialog.name.txt': () => `名稱:`,
  'ReportPropertiesDialog.description.txt': () => `說明:`,
  'ReportPropertiesDialog.keywords.txt': () => `關鍵字:`,
  'ReportPropertiesDialog.type.txt': () => `類型:`,
  'ReportPropertiesDialog.location.txt': () => `位置:`,
  'ReportPropertiesDialog.createdBy.txt': () => `建立者:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `建立日期:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `修改者:`,
  'ReportPropertiesDialog.dateModified.txt': () => `修改日期:`,
  'ReportSections.newPageButton.txt': () => `新增頁面`,
  'ReportSections.closeTab.tooltip.txt': () => `刪除頁面`,
  'ReportSections.menuButton.tooltip.fmt': ({label}) => `${label}功能表`,
  'ReportSummaryDialog.title.txt': () => `摘要`,
  'ReportSummaryDialog.open.txt': () => `開啟`,
  'ReportSummaryDialog.cancel.txt': () => `取消`,
  'ReportSummaryDialog.close.txt': () => `關閉`,
  'ReportSummaryDialog.noSummary.txt': () => `沒有可用的摘要。`,
  'ReportTileBody.modifiedBy.txt': () => `修改者:`,
  'ReportTileBody.lastModified.txt': () => `上次修改時間:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `SAS Report Viewer`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `報表重新整理`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `報表自動重新整理`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `此分鐘之後檢查更新:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `警示通知`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `選取預設警示通知:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `傳送電子郵件訊息`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `傳送 SMS 文字訊息`,
  'VAViewerSettingsProvider.alert.system.txt': () => `管理員預設`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `主題`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `覆寫報表主題並使用 SAS High Contrast 報表主題`,
  'ViewerBusyDialog.openReport.txt': () => `正在開啟報表…`,
  'ViewerBusyDialog.prepareExport.txt': () => `正在準備匯出…`,
  'ViewerBusyDialog.preparePrint.txt': () => `正在準備列印…`,
  'PDFGeneration.printingReport.txt': () => `正在產生報表 PDF。完成後即可下載。`,
  'PDFGeneration.fileName.fmt': ({date, fileName}) => `${date} 的「${fileName}」`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `選取動作`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `您已達到階層的最低一層。`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `您已達到所有階層的最低一層。`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `鑽取到「${value}」`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `${a0} ${a1} 的快照 (於 ${a2})`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `儲存影像`,
  'ObjectToolbarIcon.PrintObject.txt': () => `列印物件…`,
  'ObjectToolbarIcon.ShareObject.txt': () => `共用物件…`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `更多`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `${label} 物件功能表`,
  'ObjectToolbarIcon.Accelerator.txt': () => `使用 SAS® Graphics Accelerator 檢視`,
  'ZoomControl.button.tip.txt': () => `縮放`,
  'ZoomControl.button.zoomin.txt': () => `放大`,
  'ZoomControl.button.zoomout.txt': () => `縮小`,
  'ZoomControl.button.display.txt': () => `縮放控制項`,
  'ZoomControl.button.reset.txt': () => `重設縮放`,
  'ExpandControl.button.expand.txt': () => `最大化檢視`,
  'ExpandControl.button.restore.txt': () => `還原檢視`,
  'ExpandControl.button.expand.tip.txt': () => `最大化`,
  'ExpandControl.button.restore.tip.txt': () => `還原`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `此物件最大化時，無法執行頁面連結。`,
  'DragModeControl.button.pan.tip.txt': () => `平移`,
  'DragModeControl.button.circular.tip.txt': () => `圓形選取`,
  'DragModeControl.button.freeform.tip.txt': () => `任意範圍選取`,
  'DragModeControl.button.rectangular.tip.txt': () => `矩形選取`,
  'DragModeControl.button.zoom.tip.txt': () => `縮放到矩形`,
  'ReportXMLDialog.title.txt': () => `報表 XML`,
  'ReportXMLDialog.closeButton.txt': () => `關閉`,
  'ReportXMLDialog.copyButton.txt': () => `複製到剪貼簿`,
  'ReportXMLDialog.error.txt': () => `載入報表 XML 時發生錯誤`,
  'ErrorDialog.error.txt': () => `發生錯誤。請聯絡您的系統管理員。`,
  'Application.banner.txt': () => `SAS® Report Viewer`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics - 報表檢視器`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `開啟報表`,
  'OpenReportDialog.reports.txt': () => `報表:`,
  'OpenReportDialog.cancel.txt': () => `取消`,
  'OpenReportDialog.ok.txt': () => `確定`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `${count} 個物件已更新`,
  'AriaLive.oneObjectUpdated.txt': () => `1 個物件已更新`,
  'AriaLive.reportOpened.txt': () => `報表已開啟`,
  'AriaLive.reportClosed.txt': () => `報表已關閉`,
  'ExportData.generating.txt': () => `正在產生匯出。完成後即可下載。`,
  'ExportData.warning.txt': () => `產生資料時發生錯誤`,
  'ExportData.nodata.txt': () => `沒有匯出資料`,
  'ExportData.exportData.txt': () => `匯出資料…`,
  'PlaybackAnimationDialog.saveButton.txt': () => `儲存`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `取消`,
  'PlaybackAnimationDialog.playButton.txt': () => `播放報表`,
  'PlaybackAnimationDialog.title.txt': () => `編輯回放`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `轉換單元:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `頁面`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `物件`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `每單元秒數:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `顯示最大化物件:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `僅顯示畫布:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `顯示計時器:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `在點選或觸碰時顯示瀏覽控制項:`,
  'PlaybackNavigationControls.previousPage.txt': () => `上一頁`,
  'PlaybackNavigationControls.nextPage.txt': () => `下一頁`,
  'PlaybackNavigationControls.previousObject.txt': () => `上一個物件`,
  'PlaybackNavigationControls.nextObject.txt': () => `下一個物件`,
  'TransportConnection.generateReportTimeout.txt': () => `載入報表需要花費較長的時間。是否繼續?`,
  'TransportConnection.openReport.txt': () => `開啟報表`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `指定的報表不存在下列位置中: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `展開 ${label}`,
  'Hierarchy.collapse.fmt': ({label}) => `摺疊 ${label}`,
  'GraphElementDecorator.overview.txt': () => `概觀`,
  'GraphElementDecorator.layers.txt': () => `隱藏或顯示圖層`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `隱藏概觀`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `顯示概觀`,
  'TitleInfoButton.tooltip.txt': () => `資訊`,
  'SectionSelectionBar.noSelections.txt': () => `沒有選取項目`,
  'SectionSelectionBar.title.txt': () => `篩選:`,
  'CheckboxList.selectAll.txt': () => `全部選取`,
  'CheckboxList.clearSelection.txt': () => `清除選取項目`,
  'CheckboxList.clearSelection.fmt': ({count}) => `清除選取項目 (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `解釋${label}`,
  'ExplanationInfoDialog.loading.txt': () => `正在準備解釋…`,
  'ExplanationInfoDialog.cancel.txt': () => `取消`,
  'ExplanationInfoDialog.close.txt': () => `關閉`,
  'PromptHeader.emptyReport.txt': () => `將資料項目或控制項拖曳至此處，以建立報表提示。`,
  'PromptHeader.emptyPage.txt': () => `將資料項目或控制項拖曳至此處，以建立頁面提示。`,
  'PromptHeader.collapsePageControlArea.txt': () => `摺疊頁面控制項區域`,
  'PromptHeader.expandPageControlArea.txt': () => `展開頁面控制項區域`,
  'PromptHeader.collapseReportControlArea.txt': () => `摺疊報表控制項區域`,
  'PromptHeader.expandReportControlArea.txt': () => `展開報表控制項區域`,
  'PromptHeader.collapseControlArea.txt': () => `摺疊控制項區域`,
  'PromptHeader.expandControlArea.txt': () => `展開控制項區域`,
  'PromptHeader.reportControlArea.txt': () => `報表控制項區域`,
  'PromptHeader.allControlAreas.txt': () => `所有控制項區域`,
  'PromptHeader.pageControlArea.txt': () => `頁面控制項區域`,
  'ZeroState.editMode.txt': () => `將範本、資料項目或物件拖曳至此處。`,
  'ZeroState.viewMode.txt': () => `沒有要顯示的內容。`,
  'ObjectStatus.assignData.txt': () => `指派資料`,
  'ObjectStatus.selectImage.txt': () => `選取影像`,
  'ObjectStatus.selectJob.txt': () => `選取工作`,
  'ObjectStatus.cancelLoading.txt': () => `取消載入`,
  'ObjectStatus.loadingCanceled.txt': () => `載入已取消`,
  'ObjectStatus.resumeLoading.txt': () => `恢復載入`,
  'ObjectStatus.refresh.txt': () => `重新整理`,
  'ObjectStatus.setJobParameters.txt': () => `設定參數值`,
  'ObjectSearch.title.txt': () => `地理搜尋`,
  'ObjectSearch.pin.txt': () => `釘選`,
  'ObjectSearch.unpin.txt': () => `取消釘選`,
  'MainSearchPanel.searchHints.txt': () => `搜尋提示`,
  'MainSearchPanel.searchResults.txt': () => `搜尋結果`,
  'MainSearchPanel.features.txt': () => `功能`,
  'MainSearchPanel.pin.txt': () => `新增釘選`,
  'MainSearchPanel.pin.tooltip.txt': () => `新增釘選`,
  'MainSearchPanel.route.txt': () => `新增路線`,
  'MainSearchPanel.route.tooltip.txt': () => `新增路線`,
  'MainSearchPanel.geographicArea.txt': () => `新增地理區域`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `新增地理區域`,
  'MainSearchPanel.newMyLocationPin.txt': () => `我的地點釘選`,
  'MainSearchPanel.myLocationPin.txt': () => `我的位置`,
  'MainSearchPanel.show.txt': () => `顯示`,
  'MainSearchPanel.show.all.txt': () => `全部顯示`,
  'MainSearchPanel.hide.txt': () => `隱藏`,
  'MainSearchPanel.hide.all.txt': () => `全部隱藏`,
  'MainSearchPanel.delete.txt': () => `刪除`,
  'MainSearchPanel.delete.all.txt': () => `全部刪除`,
  'MainSearchPanel.convert.txt': () => `將搜尋結果轉換為釘選`,
  'MainSearchPanel.convert.all.txt': () => `將所有搜尋結果轉換為釘選`,
  'MainSearchPanel.showPinLabels.txt': () => `顯示釘選標籤`,
  'MainSearchPanel.close.label.txt': () => `地理搜尋`,
  'MainSearchPanel.navigate.tooltip.txt': () => `顯示詳細資料`,
  'MainSearchPanel.demographics.tooltip.txt': () => `人口統計`,
  'PanelHeader.back.tooltip.txt': () => `返回`,
  'GeographicAreaPanel.title.txt': () => `地理區域`,
  'GeographicAreaPanel.draw.txt': () => `繪製區域`,
  'GeographicAreaPanel.update.txt': () => `更新區域`,
  'GeographicAreaPanel.label.txt': () => `標籤:`,
  'GeographicAreaPanel.location.txt': () => `位置:`,
  'GeographicAreaPanel.distance.miles.txt': () => `距離 (英哩):`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `距離 (公里):`,
  'GeographicAreaPanel.distance.add.txt': () => `增加距離`,
  'GeographicAreaPanel.time.add.txt': () => `增加時間`,
  'GeographicAreaPanel.distance.delete.txt': () => `刪除距離`,
  'GeographicAreaPanel.time.minutes.txt': () => `時間 (分鐘):`,
  'GeographicAreaPanel.duration.txt': () => `持續時間:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `英哩`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `公里`,
  'GeographicAreaPanel.menu.clear.txt': () => `清除地理區域`,
  'GeographicAreaPanel.menu.link.txt': () => `預設將地址連結至資料元素和釘選`,
  'GeographicAreaPanel.menu.unlink.txt': () => `取消連結地理區域地址`,
  'GeographicAreaPanel.menu.delete.txt': () => `刪除地理區域`,
  'GeographicAreaPanel.demographics.txt': () => `人口統計`,
  'GeographicAreaPanel.demographics.set.txt': () => `顯示人口統計`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `展開檢視`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `編輯人口統計`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `刪除人口統計`,
  'GeographicAreaPanel.demographics.expired.txt': () => `必須重新載入人口統計資料`,
  'GeographicAreaPanel.demographics.reload.txt': () => `重新載入人口統計`,
  'GeographicAreaPanel.invalid.location.txt': () => `地理區域沒有有效的地點，且無法建立。`,
  'TravelTypeField.dateselector.tooltip.txt': () => `選取日和時間`,
  'TravelTypeField.cancel.txt': () => `取消`,
  'TravelTypeField.ok.txt': () => `確定`,
  'TravelTypeField.button.tooltip.txt': () => `選取日和時間`,
  'TravelTypeField.day.txt': () => `日:`,
  'TravelTypeField.time.txt': () => `時間:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `直達`,
  'TravelTypeField.distanceTypes.distance.txt': () => `距離`,
  'TravelTypeField.travelType.txt': () => `行進類型:`,
  'TravelTypeField.traffic.txt': () => `包含交通:`,
  'TravelTypeField.traffic.offset.txt': () => `交通時間偏移:`,
  'TravelTypeField.traffic.daytime.txt': () => `交通日和時間:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `距離單位`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `行車距離`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `行車時間`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `貨車運輸距離`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `貨車運輸時間`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `步行距離`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `步行時間`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `否`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `目前交通`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `一般交通`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} 小時`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `更新此功能的交通`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `更新所有功能的交通`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `更新交通資料`,
  'RoutePanel.title.txt': () => `路線`,
  'RoutePanel.draw.txt': () => `繪製路線`,
  'RoutePanel.update.txt': () => `更新路線`,
  'RoutePanel.label.txt': () => `標籤:`,
  'RoutePanel.locations.txt': () => `位置`,
  'RoutePanel.menu.clear.txt': () => `清除路線`,
  'RoutePanel.menu.reverse.txt': () => `反轉路線`,
  'RoutePanel.menu.add.waypoint.txt': () => `增加路線位置`,
  'RoutePanel.menu.delete.waypoint.txt': () => `刪除路線位置`,
  'RoutePanel.menu.unlink.txt': () => `取消連結路線位置`,
  'RoutePanel.menu.arrows.txt': () => `路線箭頭`,
  'RoutePanel.menu.arrows.hide.txt': () => `隱藏路線箭頭`,
  'RoutePanel.menu.arrows.show.txt': () => `顯示路線箭頭`,
  'RoutePanel.menu.arrows.oneway.txt': () => `單向`,
  'RoutePanel.menu.arrows.twoway.txt': () => `雙向`,
  'RoutePanel.menu.delete.txt': () => `刪除路線`,
  'RoutePanel.route.width.txt': () => `路線寬度`,
  'RoutePanel.distance.txt': () => `距離:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} 英哩`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} 公里`,
  'RoutePanel.location.add.txt': () => `增加位置`,
  'RoutePanel.location.delete.txt': () => `刪除位置`,
  'RoutePanel.duration.txt': () => `時間:`,
  'RoutePanel.invalid.location.txt': () => `路線具有無效的地點，且無法建立。`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `位置 ${index}, ${location}，輸入`,
  'PinPanel.pinTitle.txt': () => `釘選`,
  'PinPanel.addDescription.txt': () => `增加說明`,
  'PinPanel.deleteDescription.txt': () => `刪除說明`,
  'PinPanel.newPin.txt': () => `在此地點增加釘選`,
  'PinPanel.deletePin.txt': () => `刪除釘選`,
  'PinPanel.linkPins.txt': () => `預設將釘選連結至資料元素`,
  'PinPanel.unlinkAllItems.txt': () => `取消連結所有項目`,
  'PinPanel.unlinkItems.txt': () => `取消連結項目`,
  'PinPanel.label.txt': () => `標籤:`,
  'PinPanel.location.txt': () => `位置:`,
  'PinPanel.description.txt': () => `說明:`,
  'PinPanel.linked.txt': () => `已連結`,
  'PinPanel.searchClickPlaceholder.txt': () => `在地圖上搜尋或選取`,
  'PinPanel.searchPlaceholder.txt': () => `搜尋`,
  'PinPanel.addRoute.txt': () => `增加路線`,
  'PinPanel.addRoute.tooltip.txt': () => `增加路線`,
  'PinPanel.addArea.txt': () => `增加地理區域`,
  'PinPanel.addArea.tooltip.txt': () => `增加地理區域`,
  'PinPanel.addArea.title.txt': () => `增加地理區域`,
  'PinPanel.myLocationTitle.txt': () => `我的地點釘選`,
  'PinPanel.deleteMyLocationPin.txt': () => `刪除我的地點釘選`,
  'PinPanel.enableAutoUpdate.txt': () => `啟用「我的地點」自動更新`,
  'PinPanel.disableAutoUpdate.txt': () => `停用「我的地點」自動更新`,
  'PinPanel.editAutoRefreshInterval.txt': () => `編輯「我的地點」自動重新整理間隔...`,
  'PinPanel.linkToPin.txt': () => `連結至釘選`,
  'PinPanel.useCurrentLocation.txt': () => `使用目前的釘選位置`,
  'PinPanel.notDrawn.txt': () => `未繪製`,
  'PinPanel.undetermined.txt': () => `未定`,
  'PinPanel.findMyLocation.txt': () => `尋找我的地點`,
  'PinPanel.cannotDetermineLocation.txt': () => `應用程式無法判斷您目前的位置。如果要分享您的地點，請參閱瀏覽器或裝置的說明。`,
  'PinPanel.autoRefreshInterval.txt': () => `「我的地點」自動重新整理間隔`,
  'PinPanel.interval.hours.txt': () => `小時:`,
  'PinPanel.interval.minutes.txt': () => `分鐘:`,
  'PinPanel.interval.seconds.txt': () => `秒:`,
  'PinPanel.invalid.location.txt': () => `釘選沒有有效的地點，且無法建立。`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} 英哩`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}，${value2} 英哩`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}，${value2}，${value3} 英哩`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} 公里`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}，${value2} 公里`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}，${value2}，${value3} 公里`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} 分鐘`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}，${value2} 分鐘`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}，${value2}，${value3} 分鐘`,
  'PinPanel.clearLocation.tooltip.txt': () => `清除位置文字`,
  'DiscardChangesDialog.title.area.txt': () => `地理區域`,
  'DiscardChangesDialog.title.route.txt': () => `路線`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `您在區域地圖上進行變更但未重新繪製區域。\n\n您要捨棄對 ${label} 的變更嗎?`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `您在區域路徑上進行變更但未重新繪製路徑。\n\n您要捨棄對 ${label} 的變更嗎?`,
  'DiscardChangesDialog.discard.txt': () => `捨棄`,
  'DiscardChangesDialog.cancel.txt': () => `取消`,
  'FeatureErrorDialog.title.area.txt': () => `繪製地理區域`,
  'FeatureErrorDialog.title.route.txt': () => `繪製路線`,
  'FeatureErrorDialog.text.area.txt': () => `無法繪製地理區域。\n\n提示：如果您的區域地點不包含交通基礎建設（例如道路），則可能無法計算地理區域。請改用行進距離類型，或將區域移至有交通基礎建設的地點。`,
  'FeatureErrorDialog.text.route.txt': () => `無法繪製路線。\n\n提示：如果您的路線地點不包含交通基礎建設（例如道路），則可能無法計算路線。請改用行進距離類型，或將路線移至有交通基礎建設的地點。`,
  'FeatureErrorDialog.close.txt': () => `關閉`,
  'DemographicsSelectorDialog.title.txt': () => `顯示人口統計`,
  'DemographicsSelectorDialog.cancel.txt': () => `取消`,
  'DemographicsSelectorDialog.ok.txt': () => `確定`,
  'DemographicsSelectorDialog.country.txt': () => `國家/地區`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `基本`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `進階`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `最近`,
  'DemographicsSelectorDialog.categories.txt': () => `類別`,
  'DemographicsSelectorDialog.category.income.txt': () => `收入`,
  'DemographicsSelectorDialog.category.age.txt': () => `年齡`,
  'DemographicsSelectorDialog.category.households.txt': () => `家庭`,
  'DemographicsSelectorDialog.category.housing.txt': () => `住宅`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `婚姻狀態`,
  'DemographicsSelectorDialog.category.population.txt': () => `人口數`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `使用者群組`,
  'DemographicsSelectorDialog.category.health.txt': () => `健康狀況`,
  'DemographicsSelectorDialog.category.education.txt': () => `教育`,
  'DemographicsSelectorDialog.category.business.txt': () => `行業`,
  'DemographicsSelectorDialog.category.race.txt': () => `種族`,
  'DemographicsSelectorDialog.category.spending.txt': () => `支出`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `行為`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `工作`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `貧窮`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `掛毯`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `有風險`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `重要事項`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `供需`,
  'DemographicsSelectorDialog.category.policy.txt': () => `原則`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `景觀`,
  'DemographicsSelectorDialog.category.crime.txt': () => `犯罪活動`,
  'ManageColumns.title.txt': () => `管理欄`,
  'ManageColumns.ok.txt': () => `確定`,
  'ManageColumns.cancel.txt': () => `取消`,
  'ManageColumns.hiddenColumns.txt': () => `隱藏的欄`,
  'ManageColumns.displayedColumns.txt': () => `顯示的欄`,
  'SearchResultPanel.title.txt': () => `搜尋結果`,
  'SearchResultPanel.menu.delete.txt': () => `刪除搜尋結果`,
  'SearchResultPanel.convert.txt': () => `轉換為釘選`,
  'SearchResultPanel.convert.tooltip.txt': () => `轉換為釘選`,
  'DemographicsResultsDialog.title.txt': () => `人口統計`,
  'DemographicsResultsDialog.cancel.txt': () => `取消`,
  'DemographicsResultsDialog.close.txt': () => `關閉`,
  'DemographicsResultsDialog.edit.txt': () => `編輯`,
  'DemographicsResultsDialog.layout.page.txt': () => `浮動切換檢視`,
  'DemographicsResultsDialog.layout.list.txt': () => `單欄檢視`,
  'DemographicsResultsDialog.layout.tile.txt': () => `方塊檢視`,
  'DemographicsResultsDialog.noData.txt': () => `沒有資料符合目前的地理區域。`,
  'PinsAtSameLocationPanel.title.txt': () => `在相同位置的釘選`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `搜尋結果`,
  'PinsAtSameLocationPanel.pins.txt': () => `釘選`,
  'PinsAtSameLocationPanel.showAll.txt': () => `全部顯示`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `全部隱藏`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `全部刪除`,
  'PinsAtSameLocationPanel.show.txt': () => `顯示`,
  'PinsAtSameLocationPanel.hide.txt': () => `隱藏`,
  'PinsAtSameLocationPanel.delete.txt': () => `刪除`,
  'LocationPopover.pin.title.txt': () => `釘選地點`,
  'LocationPopover.area.title.txt': () => `地理區域位置`,
  'LocationPopover.route.title.txt': ({label}) => `路線位置 ${label}`,
  'LocationPopover.name.txt': () => `名稱`,
  'LocationPopover.location.txt': () => `位置:`,
  'LocationPopover.ok.txt': () => `設定地點`,
  'LocationPopover.cancel.txt': () => `結束選取項目模式`,
  'LocationPopover.hint.txt': () => `再次按一下地圖來識別不同地點。`,
  'TreeDualSelector.source.default.txt': () => `可用的項目`,
  'TreeDualSelector.target.default.txt': () => `選取的項目`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} / ${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `沒有項目`,
  'TreeDualSelector.filter.placeholder.txt': () => `篩選`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `自訂項目`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} 個項目已新增`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} 個項目已移除`,
  'TreeDualSelector.afterAction.addAll.txt': () => `所有項目皆已新增`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `所有項目皆已移除`,
  'TreeDualSelector.afterAction.up.txt': () => `上移`,
  'TreeDualSelector.afterAction.down.txt': () => `下移`,
  'TreeDualSelector.afterAction.top.txt': () => `移至頂部`,
  'TreeDualSelector.afterAction.bottom.txt': () => `移至底部`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `已還原新增動作`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `已還原移除動作`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `加入的自訂項目`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `已選取 ${customItemSelected} 自訂項目`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `已選取 ${itemSelected} ${itemDescription} 個`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `已選取 ${itemSelected}`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `在 ${targetListLabel} 上移一列`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `在 ${targetListLabel} 下移一列`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `移動到 ${targetListLabel} 頂部`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `移動到 ${targetListLabel} 底部`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `將項目增加至 ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `全部增加至 ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `從 ${targetListLabel} 移除項目`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `從 ${targetListLabel} 全部移除`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `復原 ${targetListLabel} 的增加`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `復原 ${targetListLabel} 的移除`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `篩選 ${listLabel}`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `移除`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `如果繼續進行，您所選的任何要刪除之自訂項目將會永久刪除。\n\n是否要繼續？`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `移除所有項目`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `如果繼續進行，此清單中的自訂項目將會永久刪除。\n\n是否要繼續？`,
  'LinkNavigator.backButton.label': () => `返回`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `傳入篩選`,
  'LinkNavigator.reportLevel.label': () => `報表層級`,
  'LinkNavigator.sectionLevel.label': () => `頁面層級`,
  'ReportSectionZeroState.heading.label': () => `設計報表`,
  'ReportSectionZeroState.description.label': () => `將物件或資料項目拖曳至頁面上，或選取下列選項。`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `將物件或資料項目拖曳至頁面上，或從頁面範本開始。`,
  'ReportSectionZeroState.autoChartButton.label': () => `產生物件`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `選取範本`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `探索建議`,
  'PromptContainerTooltip.noSelections.txt': () => `沒有選取項目`,
  'PromptContainerTooltip.selectedValues.txt': () => `選取的值`,
}
export default localizers;
